import axios from 'axios';
import {
  unauthorizedInterceptor as interceptor
} from '~/helpers/_core/axios';

export default ({ app }, inject) => {
  inject('axios', {
    create(options = null) {
      try {
        const instance = axios.create(options);

        return instance;
      } catch (err) {
        console.error('Error/Axios/Plugin', err);
      }
    },
    async unauthorizedInterceptor(error) {
      interceptor(app, error);
    }
  });
};
